import type { ReactNode } from 'react';
import logoDark from '../assets/logo-horizontal-branco.svg';
import { useTheme } from '../lib/theme';

/** Centered card with the logo and the printed-layer stripes (design/Login.dc.html). */
export function AuthLayout({ children }: { children: ReactNode }) {
  const { dz, dark } = useTheme();
  return (
    <div
      className={dz}
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 16px 0',
        overflow: 'hidden',
      }}
    >
      <div className="col" style={{ width: '100%', maxWidth: 420, gap: 28, alignItems: 'center' }}>
        <img
          src={dark ? logoDark : '/api/v1/brand/logo.png'}
          alt="Deizi3d"
          style={{ width: 240, height: 'auto', display: 'block' }}
        />
        {children}
      </div>
      <div
        aria-hidden="true"
        style={{
          width: '100%',
          marginTop: 56,
          display: 'flex',
          flexDirection: 'column',
          gap: 6,
          maxWidth: 900,
        }}
      >
        {[
          ['#FFD9D3', '62%'],
          ['#FFD9D3', '74%'],
          ['#FF5C5C', '84%'],
          ['#FF5C5C', '92%'],
          ['#FF5C5C', '100%'],
        ].map(([bg, w]) => (
          <div
            key={w}
            style={{ height: 8, borderRadius: 4, background: bg, width: w, margin: '0 auto' }}
          />
        ))}
      </div>
    </div>
  );
}
